import React, { useState } from "react";
import { Step, Stepper } from "react-form-stepper";
import MobileVerification from "./MobileVerification";
import PanVerification from "./PanVerification";
import AadharVerification from "./AadharVerification";
import AccountDetails from "./AccountDetails";
import { toast, ToastContainer } from "react-toastify";
import DocsUpload from "./DocsUpload";
import EsignAgreement from "./EsignAgreement";
import { store } from "../../../../../utils/redux/store";

const ProfileSteps = (props) => {
  const isAadharVerified = props.$store?.user?.is_aadhar_verified;
  const isPanVerified = props.$store?.user?.is_pan_code_verified;
  const isNumberVerified = props.$store?.user?.is_phone_number_verified;
  const isAccountVerified = props.$store?.user?.isAccountVerified;
  const isDocsVerified = props.$store?.user?.isDocsVerified;
  const isEsigned = props.$store?.user?.is_agreement_signed;

  const [currentAadhaarVerified, setCurrentAadhaarVerified] = useState(null);
  const [pandetails, setPandetails] = useState({});
  //
  const [showMobileVerify, setShowMobileVerify] = useState(false);
  const [usermobilenum, setUsermobilenum] = useState(null);
  //
  const [showAadharVerify, setShowAadharVerify] = useState(false);
  const [showAadharDetails, setShowAadharDetails] = useState(false);

  const [showPanVerify, setShowPanVerify] = useState(false);
  const [showPanDetails, setShowPanDetails] = useState(false);
  //

  const toastConfig = {
    autoClose: 3000,
    closeButton: false,
    hideProgressBar: true,
  };

  // MOBILE
  const onMobileSubmit = (e, data) => {
    e.preventDefault();
    console.log({ onMobileSubmit: data });
    setUsermobilenum(data?.mobileNumber);
    let payload = {
      mobileNumber: data?.mobileNumber,
    };
    let updatePayload = {
      mobileNumber: data?.mobileNumber,
      emailAddress: data?.emailAddress,
      alternateMobileNumber: data?.alternateMobileNumber,
    };
    props.apis.apiKycSendOTP(payload).then((res) => {
      console.log({ apiKycSendOTP: res });
      setShowMobileVerify(true);
      toast.success("OTP Sent Successfully", toastConfig);
      let mobileVerifyBtn = document.querySelector("#mobileVerifyBtn");
      if (mobileVerifyBtn) {
        mobileVerifyBtn.disabled = true;
      }
    });

    props.apis.apiUpdateEmployee(updatePayload).then((res) => {
      // console.log({ apiUpdateEmployee: res });
      // swal2.fire({
      //   title: "Digi Team Member updated successfully.",
      //   icon: "success",
      //   iconColor: "#234C9B",
      //   timer: 4000,
      // });
    });
  };

  const onMobileVerify = (e, otpcode) => {
    e.preventDefault();
    console.log({ onMobileVerify: e, otpcode });
    let payload = {
      mobileNumber: usermobilenum,
      otp: otpcode,
    };
    props.apis.apiKycVerifyOTP(payload).then((res) => {
      console.log({ apiKycVerifyOTP: res });
      toast.success("Mobile No. Verified Successfully", toastConfig);
      props.store("user", {
        ...props?.$store?.user,
        isNumberVerified: true,
      });
      props.setGoSteps(1);
      setShowMobileVerify(false);
      setUsermobilenum(null);
    });
  };

  const handleMobileResend = () => {
    let payload = {
      mobileNumber: usermobilenum,
    };
    props.apis.apiKycSendOTP(payload).then((res) => {
      console.log({ apiKycSendOTP: res });
      setShowMobileVerify(true);
      toast.success("OTP Sent Successfully", toastConfig);
    });
  };

  // TOGGLE FUNCTION
  const handleAadharDetailsShow = () => {
    setShowAadharDetails(true);
  };
  const handleAadharDetailsClose = () => {
    setShowAadharDetails(false);
  };

  // PAN
  const onPanCheck = (e, data) => {
    e.preventDefault();
    console.log({ onPanCheck: data });
    setShowPanVerify(true);
    toast.success("OTP Sent Successfully", toastConfig);
  };

  const onPanVerify = (e, data) => {
    e.preventDefault();
    console.log({ onPanVerify: data });
    let payload = {
      pan: data.panNumber,
    };
    console.log({ payload });
    props.apis.apiGetConnectorPanDetails(payload).then((res) => {
      console.log({ apiGetConnectorPanDetails: res });
      setPandetails(res);
      setShowPanDetails(true);
    });
  };

  // TOGGLE FUNCTION
  const handlePanDetailsShow = () => {
    setShowPanDetails(true);
  };
  const handlePanDetailsClose = () => {
    setShowPanDetails(false);
  };

  const onPanSubmit = (e) => {
    e.preventDefault();
    if (pandetails) {
      let payload = { ...Object.except(pandetails, "status") };

      props.apis.apiVerifyConnectorPanDetails(payload).then((res) => {
        console.log({ apiVerifyConnectorPanDetails: res });
        toast.success("PAN Verified Successfully", toastConfig);
        props.store("user", {
          ...props?.$store?.user,
          is_pan_code_verified: true,
        });
        props.setGoSteps(3);
        setShowPanDetails(false);
      });
    }
  };

  const onAccountSubmit = (e) => {
    e.preventDefault();
    let data = e.target.getData();
    let payload = {
      ...Object.except(data, ["acknowledgement", "reEnterAccountNumber"]),
    };

    // check if account number matches with re-enter account number
    if (data?.bank_account_number !== data?.reEnterAccountNumber) {
      toast.error(
        "Account No. and Re-enter account No. did not match",
        toastConfig
      );
      return;
    }

    const bankObjKeys = [
      "bank_account_holder_name",
      "bank_account_number",
      "reEnterAccountNumber",
      "bank_account_type",
      "bank_account_holder_bank_name",
      "bank_account_holder_bank_IFSC",
    ];

    if (
      props?.myinfo?.created_by_connector_bank_account_details?.length === 0
    ) {
      // add acc info
      props.apis.apiAddConnectorBankDetails(payload).then((res) => {
        let fObjs = Object.only(res?.data, bankObjKeys);
        const allValid = Object.values(fObjs).every(
          (value) => value !== null && value !== undefined && value !== ""
        );

        props.store("user", {
          ...props?.$store?.user,
          created_by_connector_bank_account_details: [data],
          isAccountVerified: allValid,
        });
        props.setGoSteps(4);
      });
    } else {
      // update acc info
      props.apis.apiUpdateConnectorBankDetails(payload).then((res) => {
        let fObjs = Object.only(res?.data, bankObjKeys);
        const allValid = Object.values(fObjs).every(
          (value) => value !== null && value !== undefined && value !== ""
        );

        console.log({ allValid });

        props.store("user", {
          ...props?.$store?.user,
          created_by_connector_bank_account_details: [data],
          isAccountVerified: allValid,
        });
        props.setGoSteps(4);
      });
    }
  };

  const handleStep = (e, step) => {
    e.preventDefault();
    console.log({ step });
    props.setGoSteps(step);
  };

  // STORE LISTENER FOR AADHAAR VERIFIED FLAG CHANGES
  store?.subscribe(() => {
    const currentState = store.getState();
    const currentIsAadharVerified = currentState?.store?.user?.isAadharVerified;

    if (currentIsAadharVerified !== isAadharVerified) {
      setCurrentAadhaarVerified(currentIsAadharVerified);
    }
  });

  return (
    <>
      <ToastContainer />
      <div className="form-wizard">
        <Stepper
          className="nav-wizard profile_stepper"
          id="customStepper"
          activeStep={props.goSteps}
        >
          <Step
            className={Object.className({
              "nav-link": true,
              current: props.goSteps === 0 ? true : false,
            })}
            label={`Basic Details`}
            onClick={() => props.setGoSteps(0)}
            stepClassName="mobile"
            disabled={false}
            completed={isNumberVerified}
          />
          <Step
            className={Object.className({
              "nav-link": true,
              current: props.goSteps === 1 ? true : false,
            })}
            label="Aadhar Verification"
            onClick={() => props.setGoSteps(1)}
            stepClassName="aadhar"
            disabled={false}
            completed={currentAadhaarVerified || isAadharVerified}
          />
          <Step
            className={Object.className({
              "nav-link": true,
              current: props.goSteps === 2 ? true : false,
            })}
            label="PAN Verification"
            onClick={() => props.setGoSteps(2)}
            stepClassName="pan"
            disabled={false}
            completed={isPanVerified || pandetails?.length > 0}
          />
          <Step
            className={Object.className({
              "nav-link": true,
              current: props.goSteps === 3 ? true : false,
            })}
            label="Account Details"
            onClick={() => props.setGoSteps(3)}
            stepClassName="account"
            disabled={false}
            completed={isAccountVerified || false}
          />
          <Step
            className={Object.className({
              "nav-link": true,
              current: props.goSteps === 4 ? true : false,
            })}
            label="Document Upload"
            onClick={() => props.setGoSteps(4)}
            stepClassName="docsupload"
            disabled={false}
            completed={isDocsVerified || false}
          />
          <Step
            className={Object.className({
              "nav-link": true,
              current: props.goSteps === 5 ? true : false,
            })}
            label="E-Sign Agreement"
            onClick={() => props.setGoSteps(5)}
            stepClassName="esignagreement"
            // disabled={false}
            completed={isEsigned}
          />
        </Stepper>
        {props.goSteps === 0 && (
          <>
            <MobileVerification
              skipToStep={(...args) => skipToStep(...args)}
              onMobileSubmit={(...args) => onMobileSubmit(...args)}
              onMobileVerify={(...args) => onMobileVerify(...args)}
              handleMobileResend={(...args) => handleMobileResend(...args)}
              showMobileVerify={showMobileVerify}
              onHandleStep={(...args) => handleStep(...args)}
              myinfo={props.myinfo}
            />
          </>
        )}
        {props.goSteps === 1 && (
          <>
            <AadharVerification
              showAadharVerify={showAadharVerify}
              showAadharDetails={showAadharDetails}
              handleAadharDetailsShow={handleAadharDetailsShow}
              handleAadharDetailsClose={handleAadharDetailsClose}
              onHandleStep={(...args) => handleStep(...args)}
              onModalClose={(...args) => props.onModalClose(...args)}
            />
          </>
        )}
        {props.goSteps === 2 && (
          <>
            <PanVerification
              showPanVerify={showPanVerify}
              onPanVerify={(...args) => onPanVerify(...args)}
              onPanSubmit={(...args) => onPanSubmit(...args)}
              showPanDetails={showPanDetails}
              handlePanDetailsShow={handlePanDetailsShow}
              handlePanDetailsClose={handlePanDetailsClose}
              pandetails={pandetails}
              onHandleStep={(...args) => handleStep(...args)}
              myinfo={props.myinfo}
            />
          </>
        )}
        {props.goSteps === 3 && (
          <>
            <AccountDetails
              onAccountSubmit={(...args) => onAccountSubmit(...args)}
              onHandleStep={(...args) => handleStep(...args)}
              myinfo={props.myinfo}
            />
          </>
        )}
        {props.goSteps === 4 && (
          <>
            <DocsUpload
              onHandleStep={(...args) => handleStep(...args)}
              myinfo={props.myinfo}
              setGoSteps={props.setGoSteps}
            />
          </>
        )}
        {props.goSteps === 5 && (
          <>
            <EsignAgreement
              handleEsignSubmit={(...args) => props.handleEsignSubmit(...args)}
              onModalClose={(...args) => props.onModalClose(...args)}
              onHandleStep={(...args) => handleStep(...args)}
            />
          </>
        )}
      </div>
    </>
  );
};

export default constore(ProfileSteps);
